import React from "react";
import { invokeApi } from "../../../../bl_libs/invokeApi";
import {
  Completed,
  FeedbackGiven,
  MoveInProgress,
  ReadyToMove,
  WaitingForConfirmation,
} from "./components";

function Reques(props) {
  const { requestData, fetchRequestDetails } = props;
  const { id, request_timeline_status } = requestData.request;

  const bidCancel = () => {
    let requestObj = {
      path: "/api/company/bid_cancel",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${id}`,
    };
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      console.log(res);
      if (res.code === 200) {
        document.getElementById("close-bid-cancel").click();
        fetchRequestDetails();
      }
    });
  };

  if (request_timeline_status === 4) {
    return (
      <ReadyToMove
        requestData={requestData}
        fetchRequestDetails={fetchRequestDetails}
      />
    );
  }
  if (request_timeline_status === 5) {
    return (
      <MoveInProgress
        requestData={requestData}
        fetchRequestDetails={fetchRequestDetails}
      />
    );
  }
  if (request_timeline_status === 6) {
    return <WaitingForConfirmation requestData={requestData} />;
  }
  if (request_timeline_status === 7) {
    return (
      <Completed
        requestData={requestData}
        fetchRequestDetails={fetchRequestDetails}
      />
    );
  }
  if (request_timeline_status === 8) {
    return <FeedbackGiven requestData={requestData} />;
  }
  return <></>;
}

export default Reques;
